// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("core.ruffle." + {"110":"3307b81f686c1903a5fc","993":"d3f0af5ab29d1c046f91"}[chunkId] + ".js");